import React from 'react';
import { Linkedin, Phone, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="w-full bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 py-12">

        {/* Contact Cards with Logo in Center */}
        <div className="flex flex-col lg:flex-row justify-center items-center gap-8 lg:gap-12">
          
          {/* Kerrye Tabaczka - Left */}
          <div className="bg-gray-50 rounded-xl p-6 text-center shadow-sm hover:shadow-md transition-shadow min-w-[280px]">
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Kerrye Tabaczka</h3>
            <div className="space-y-3">
              <a 
                href="tel:407-694-8102" 
                className="flex items-center justify-center gap-2 text-gray-600 hover:text-gray-900 transition-colors"
              >
                <Phone size={18} className="text-teal-500" />
                <span>407-694-8102</span>
              </a>
              <a 
                href="mailto:Kerrye@scanyourhealth.net" 
                className="flex items-center justify-center gap-2 text-gray-600 hover:text-gray-900 transition-colors"
              >
                <Mail size={18} className="text-teal-500" />
                <span>Kerrye@scanyourhealth.net</span>
              </a>
              <a 
                href="https://www.linkedin.com/in/kerrye-tabaczka-56566613/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 text-gray-600 hover:text-[#0077b5] transition-colors"
              >
                <Linkedin size={18} className="text-[#0077b5]" />
                <span>LinkedIn Profile</span>
              </a>
            </div>
          </div>

          {/* Logo - Center */}
          <a href="/" className="flex items-center flex-shrink-0">
            <img 
              src="https://customer-assets.emergentagent.com/job_prysm-replica/artifacts/dewbb5pm_Untitled%20design%20%2829%29.png" 
              alt="BioWell Solutions" 
              className="h-40 md:h-52 w-auto"
            />
          </a>

          {/* Jim Mergenthaler - Right */}
          <div className="bg-gray-50 rounded-xl p-6 text-center shadow-sm hover:shadow-md transition-shadow min-w-[280px]">
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Jim Mergenthaler</h3>
            <div className="space-y-3">
              <a 
                href="tel:407-694-4927" 
                className="flex items-center justify-center gap-2 text-gray-600 hover:text-gray-900 transition-colors"
              >
                <Phone size={18} className="text-teal-500" />
                <span>407-694-4927</span>
              </a>
              <a 
                href="mailto:Jim@scanyourhealth.net" 
                className="flex items-center justify-center gap-2 text-gray-600 hover:text-gray-900 transition-colors"
              >
                <Mail size={18} className="text-teal-500" />
                <span>Jim@scanyourhealth.net</span>
              </a>
              <a 
                href="https://www.linkedin.com/in/jmergenthaler/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 text-gray-600 hover:text-[#0077b5] transition-colors"
              >
                <Linkedin size={18} className="text-[#0077b5]" />
                <span>LinkedIn Profile</span>
              </a>
            </div>
          </div>

        </div>

        {/* Privacy Policy Link */}
        <div className="mt-8 text-center">
          <a 
            href="https://legal.nuskin.com/privacy.html" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-500 text-sm hover:text-gray-700 hover:underline transition-colors"
          >
            Privacy Policy
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
